import React from 'react'

export default class PublucOffer extends React.Component {

  componentDidMount = () => {
    window.scrollTo(0, 0)
  }

  render = () =>
    <div className="light">
      <ol className="ui list">
        <li>Термины и определения<br />
          <ol>
            <li>В настоящей оферте, если из контекста не следует иное, нижеприведенные термины с заглавной буквы имеют следующие
      значения.<br />
              <ol>
                <li>"Курьерская служба" - лица, оказывающие услуги по доставке Товаров от имени Продавца, или сотрудники Продавца.</li>
                <li>"Продавец" - юридическое лицо ООО "Олимп", ОГРН 1092309002378 / ИНН 2309117400, созданное в соответствии с
                  законодательством Российской Федерации и осуществляющее предпринимательскую деятельность по продаже Товаров, в
          том числе дистанционным способом.</li>
                <li>"Покупатель" - любое дееспособное лицо, намеренное заказать или приобрести, либо заказывающий, приобретающий
                  или использующий Товары исключительно для личных, семейных, домашних или иных нужд, не связанных с осуществлением
          предпринимательской деятельности.</li>
                <li>"Сайт" - cityparkvip.ru</li>
                <li>"Телефон" - номер телефона, указанный на сайте cityparkvip.ru</li>
                <li>"Товары" - перечень продукции Продавца, представленный на Сайте. Потребительские свойства, срок годности
          Товара указаны на Сайте. Товары могут отличаться от изображения на Сайте.</li>
              </ol>
            </li>
            <li>Для целей настоящей оферты термины и определения в единственном числе относятся также и к терминам и
      определениям во множественном числе.</li>
          </ol>
        </li>
        <li>Общие положения<br />
          <ol>
            <li>Продавец и Покупатель гарантируют, что обладают необходимой право- и дееспособностью, а также всеми правами,
      необходимыми для заключения и исполнения договора розничной купли-продажи дистанционным способом.</li>
            <li>Покупатель обязуется ознакомиться с условиями настоящей оферты, с информацией, указанной на Сайте в отношении
      Товаров, с условиями участия в Программе лояльности, Политикой Конфиденциальности, Пользовательским соглашением.</li>
            <li>Продавец оставляет за собой право вносить изменения в настоящую оферту, в связи с чем Покупатель обязуется
      самостоятельно отслеживать наличие изменений в настоящей оферте.</li>
            <li>При оформлении заказа Товаров Покупатель тем самым подтверждает, что он исполнил обязанности, предусмотренные
      пунктом 2.2. настоящей оферты.</li>
            <li>Договор розничной купли-продажи дистанционным способом считается заключенным с момента получения Продавцом
      сообщения о намерении Покупателя приобрести Товары.</li>
            <li>Срок, в течение которого действует предложение о заключении договора розничной купли-продажи дистанционным
      способом, является бессрочным.</li>
          </ol>
        </li>
        <li>Предмет Договора<br />
          <ol>
            <li>Продавец продает Товары по ценам, представленным на Сайте Продавца, и доставляет Товар Курьерской службой, а
      Покупатель производит оплату и принимает Товары в соответствии с условиями настоящей оферты.</li>
            <li>Право собственности на Товары переходит к Покупателю в момент приемки Товаров Покупателем.</li>
          </ol>
        </li>
        <li>Уведомления Покупателя<br />
          <ol>
            <li>Продавец вправе осуществлять рассылку уведомлений о проводимых акциях и рекламных материалов Пользователю по
      сетям электросвязи, при условии получения от Пользователя согласия на совершение указанных действий.</li>
            <li>Покупатель имеет право в любой момент отписаться от уведомлений, указанных в пункте 4.1. настоящей оферты, и
      подписаться на уведомления вновь.</li>
            <li>Продавец вправе совершать вызовы в адрес Пользователя в целях проведения маркетинговых исследований среди
              Покупателей и исследования предпочтений Покупателей; проведения розыгрышей призов среди Покупателей; проведения
              анализа оказываемых Продавцом услуг; урегулирования конфликтных ситуаций без получения от Пользователя согласия на
      совершение всех перечисленных выше действий.</li>
            <li>Продавец вправе отправлять сервисные сообщения, информирующие Покупателя о совершенном им заказе, его составе,
              этапах его обработки и о готовности заказа; такие сервисные сообщения отправляются автоматически, не могут быть
              отклонены Покупателем, направлены на контроль качества оказания услуг Покупателю и его информирование о надлежащем
      исполнении Продавцом своих обязательств по договору купли-продажи дистанционным способом.</li>
          </ol>
        </li>
        <li>Оформление заказа Товаров<br />
          <ol>
            <li>Заказ Покупателя может быть оформлен по Телефону и/или посредством заполнения электронной формы заказа на Сайте.</li>
            <li>Покупатель обязуется предоставить достоверные данные, необходимые и достаточные для исполнения договора
      розничной купли-продажи Товаров дистанционным способом.</li>
            <li>В случае возникновения у Покупателя дополнительных вопросов, касающихся Товаров, перед оформлением Заказа,
              Покупатель должен обратиться к Продавцу по Телефону для получения необходимой информации, в соответствии с режимом
      работы, указанным на Сайте.</li>
            <li>Покупатель может заказать только те Товары, которые есть в наличии у Продавца в момент оформления заказа Товаров
      у Продавца.</li>
            <li>Покупатель не имеет право изменить состав заказа.</li>
            <li>При оформлении заказа по Телефону Продавец вправе осуществлять аудиозапись телефонного разговора с
              Пользователем, если указанные действия необходимы Продавцу для исполнения обязанностей, предусмотренных настоящей
              офертой, и оценки качества оказанных услуг, без получения от Пользователя согласия на совершение указанных
      действий.</li>
            <li>При оформлении заказа посредством заполнения электронной формы заказа на Сайте Покупатель создает учетную запись
      в соответствии с Пользовательским соглашением, указанным на Сайте.</li>
            <li>Если у Продавца отсутствует необходимое количество или ассортимент заказанных Покупателем Товаров, Продавец
              информирует об этом Покупателя по телефону в течение 60 минут после получения заказа Товаров от Покупателя.
              Покупатель вправе согласиться принять Товары в ином количестве или ассортименте, либо аннулировать свой заказ
      Товаров. в случае неполучения ответа Покупателя Продавец вправе аннулировать Заказ Покупателя в полном объеме.</li>
            <li>Продавец вправе временно приостановить прием заказов Товаров в случае технических неполадок, не позволяющих
      принять заказа Товаров, или отсутствия ингредиентов, необходимых для изготовления Товаров.</li>
          </ol>
        </li>
        <li>Доставка Товаров<br />
          <ol>
            <li>Доставка Товаров осуществляется Курьерской службой по фактическому адресу, указанному Покупателем, при
      оформлении заказа или выборкой Товаров Покупателем (самовывозом).</li>
            <li>Доставка Товаров в пределах зоны доставки осуществляется в соответствии с режимом работы Продавца, указанным на
      Сайте.</li>
            <li>Доставка Товаров по адресам, не входящим в зону доставки, не осуществляется.</li>
            <li>Срок доставки заказа Товаров – 60 минут с момента принятия заказа Товаров. в случае нарушения установленных
              сроков доставки Товаров, в силу обстоятельств непреодолимой силы ("форс-мажор") в соответствии с Разделом 9
      настоящей оферты Продавец не считается просрочившим доставку.</li>
            <li>Доставка осуществляется при условии заказа Товаров на сумму минимального заказа. Сумма минимального заказа
      определяется Продавцом в одностороннем порядке и указывается на Сайте.</li>
            <li>Продавец вправе отказаться от исполнения договора розничной купли-продажи дистанционным способом в том случае,
              если Курьерская служба по прибытии к фактическому адресу доставки Покупателя, не может осуществить фактическую
              передачу доставленных Товаров по вине Покупателя (Покупатель в течение 10 минут не отвечает на телефонный вызов или
      не открывает дверь Курьерской службе).</li>
          </ol>
        </li>
        <li>Оплата Товаров<br />
          <ol>
            <li>Цены на Товары определяются Продавцом в одностороннем порядке и указываются на Сайте. Цена на заказанный
      Покупателем Товар изменению не подлежит.</li>
            <li>Оплата Товаров Покупателем производится в рублях Российской Федерации одним из следующих способов:<br />
              <ol>
                <li>оплата осуществляется по факту получения Товаров наличными денежными средствами, оплата наличными денежными
                  средствами ограничена максимальной суммой. Максимальная сумма заказа, при которой возможна оплата наличными
                  денежными средствами, определяется Продавцом в одностороннем порядке и указывается на Сайте. Заказ превышающий
          размер максимальной суммы оплачивается в соответствии с п.7.2.2. настоящей оферты;</li>
                <li>безналичными расчетами банковской картой на Сайте. в соответствии с положением ЦБ РФ "Об эмиссии банковских
                  карт и об операциях, совершаемых с использованием платежных карт" № 266-П от 24.12.2004 года операции по
          банковским картам совершаются держателем карты либо уполномоченным им лицом;</li>
                <li>безналичными расчетами банковской картой по факту получения Товаров, при условии оснащения Курьерской службы
                  мобильными POS-терминалами (о наличии возможности произвести оплату Товаров данным способом следует уточнять у
          Продавца).</li>
              </ol>
            </li>
            <li>Выдача либо направление Покупателю кассового чека:<br />
              <ol>
                <li>На бумажном носителе, в случае совершения заказа Товаров через Телефон и оплаты в порядке, предусмотренном
                  пунктом 7.2.1 настоящей оферты, пунктом 7.2.3 настоящей оферты, если Покупатель в момент совершения заказа не
                  сообщил Продавцу о желании получить кассовый чек в электронном виде, и не выполнил условия, предусмотренные
          пунктом 7.4.2 настоящей оферты.</li>
                <li>В электронном виде на электронную почту Покупателя, в случае совершения заказа Товаров через Сайт и оплаты
                  Товаров в порядке, предусмотренном пунктом 7.2.2 настоящей оферты, если Покупатель выполнил условия пункта 7.4.1.
          настоящей оферты.</li>
                <li>В электронном виде способом, технически доступным для Продавца, в случае совершения заказа Товаров через Сайт
                  и оплаты Товаров в порядке, предусмотренном пунктом 7.2.2 настоящей оферты, если Покупатель не выполнил условия
          пункта 7.4.1. настоящей оферты.</li>
              </ol>
            </li>
            <li>Условия направления кассового чека в электронном виде:<br />
              <ol>
                <li>Внесение Покупателем данных об адресе электронной почты в личную учетную запись на Сайте при регистрации в
          порядке, предусмотренном Пользовательским соглашением.</li>
                <li>Внесение Покупателем данных об адресе электронной почты в личную учетную запись на Сайте при регистрации в
                  порядке, предусмотренном Пользовательским соглашением, и при условии совершения Покупателем заказа Товаров с
                  номера телефона, который идентичен номеру телефона, внесенному Покупателем в личной учетной записи на Сайте в
          порядке, предусмотренном Пользовательским соглашением.</li>
              </ol>
            </li>
          </ol>
        </li>
        <li>Возврат и обмен Товаров<br />
          <ol>
            <li>Возврат Товара надлежащего качества не допускается.</li>
            <li>Продавец обязан передать Покупателю Товары, которые полностью соответствуют его заказу, качество которых
              соответствует информации, представленной Покупателю при заключении договора розничной купли-продажи дистанционным
              способом, а также информации, доведенной до его сведения при передаче Товаров (на этикетке или вкладыше,
      прикрепленных к Товарам или их упаковке, либо другими способами, предусмотренными для отдельных видов Товаров).</li>
            <li>При получении Товаров Покупатель проверяет соответствие полученных Товаров своему заказу, комплектность и
      отсутствие претензий к внешнему виду доставленных Товаров в течение 10 (Десяти) минут после получения Товаров.</li>
            <li>В случае получения некачественных Товаров, либо несоответствия полученных Товаров заказанному (отсутствие
              заявленных ингредиентов в Товаре), Покупатель вправе потребовать замены таких Товаров Товарами надлежащего качества
      сразу в течение 5 (Пяти) минут после получения Товаров.</li>
            <li>В случае невыполнения порядка предъявления претензии Покупателя по внешнему виду Товаров и их комплектности,
      предусмотренных пунктом 8.3, пунктом 8.4 настоящей оферты, претензии не принимаются.</li>
          </ol>
        </li>
        <li>Форс-мажор<br />
          <ol>
            <li>Любая из Сторон освобождается от ответственности за полное или частичное неисполнение своих обязательств по
              настоящей оферте, если это неисполнение было вызвано обстоятельствами непреодолимой силы. Обстоятельства
              непреодолимой силы означают чрезвычайные события и обстоятельства, которые Стороны не могли ни предвидеть, ни
              предотвратить разумными средствами. Такие чрезвычайные события или обстоятельства включают в себя, в частности:
      забастовки, наводнения, пожары, землетрясения и иные стихийные бедствия, войны, военные действия и так далее.</li>
          </ol>
        </li>
        <li>&nbsp;Ответственность Сторон публичной оферты<br />
          <ol>
            <li>Продавец не несет ответственnности за ущерб, причиненный Покупателю вследствие ненадлежащего использования им
      Товаров, приобретённых у Продавца.</li>
            <li>Продавец не отвечает за убытки Покупателя, возникшие в результате неправильного заполнения Заказа, в том числе
      неправильного указания своих данных.</li>
            <li>В случае злоупотребления Покупателем правами потребителя, включая, но не ограничиваясь, если Покупатель
              отказался от приемки и/или оплаты заказанного и доставленного Товара, Продавец вправе реализовать свое право на
      самозащиту, а именно: не принимать от него будущие Заказы.</li>
            <li>В случае одностороннего отказа Продавца от исполнения договора розничной купли-продажи дистанционным способом в
              соответствии с пунктом 6.6. настоящей публичной оферты, Продавец вправе вправе реализовать свое право на
              самозащиту, взыскать убытки с Покупателя. в случае, если Покупатель оплатил Товар до его доставки, оплаченная сумма
      не возвращается.</li>
          </ol>
        </li>
      </ol>
    </div>
}


// WEBPACK FOOTER //
// ./src/features/PublicOffer/components/PublicOffer/PublicOffer.js